<template>
  <div class="chips-container">
    <v-tooltip top open-on-hover open-on-focus open-delay="1000">
      <template v-slot:activator="{ on }">
        <v-chip
          outlined
          label
          small
          class="sentiment-chip"
          :class="{
            active: selection.includes('negative'),
            xsmall: countNegative.length > 4,
            hasCount: countNegative.length,
          }"
          @click="toggleSelection('negative')"
          v-on="on"
        >
          Negative
          <span v-if="countNegative" class="negative-count"
            >({{ countNegative }})</span
          >
        </v-chip>
      </template>
      <span v-if="!selection.includes('negative')"
        >Show events with a negative sentiment</span
      >
      <span v-if="selection.includes('negative')"
        >Remove negative sentiment filter</span
      >
    </v-tooltip>
    <v-tooltip top open-on-hover open-on-focus open-delay="1000">
      <template v-slot:activator="{ on }">
        <v-chip
          outlined
          label
          small
          class="sentiment-chip"
          :class="{
            active: selection.includes('neutral'),
            xsmall: countNeutral.length > 4,
            hasCount: countNegative.length,
          }"
          @click="toggleSelection('neutral')"
          v-on="on"
        >
          Neutral
          <span v-if="countNeutral" class="neutral-count"
            >({{ countNeutral }})</span
          >
        </v-chip>
      </template>
      <span v-if="!selection.includes('neutral')"
        >Show events with a neutral sentiment</span
      >
      <span v-if="selection.includes('neutral')"
        >Remove neutral sentiment filter</span
      >
    </v-tooltip>
    <v-tooltip top open-on-hover open-on-focus open-delay="1000">
      <template v-slot:activator="{ on }">
        <v-chip
          outlined
          label
          small
          class="sentiment-chip"
          :class="{
            active: selection.includes('positive'),
            xsmall: countPositive.length > 4,
            hasCount: countNegative.length,
          }"
          @click="toggleSelection('positive')"
          v-on="on"
        >
          Positive
          <span v-if="countPositive" class="positive-count"
            >({{ countPositive }})</span
          >
        </v-chip>
      </template>
      <span v-if="!selection.includes('positive')"
        >Show events with a positive sentiment</span
      >
      <span v-if="selection.includes('positive')"
        >Remove positive sentiment filter</span
      >
    </v-tooltip>
  </div>
</template>

<script>
import { formatBigNumber } from "@/common/basic.utilities";
import { EVENT_ACTIONS, SEARCH_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};
export default {
  name: "SearchFilterSentiment",
  props: {
    filterCounts: {
      type: Object,
      default() {
        return {
          negative: null,
          neutral: null,
          positive: null,
        };
      },
    },
    incomingSelection: {
      type: Array,
    },
  },
  data: function () {
    return {
      selection: [],
    };
  },
  computed: {
    countNegative() {
      const count =
        typeof this.filterCounts?.negative === "number"
          ? this.filterCounts.negative
          : null;

      return formatBigNumber(count)?.toString() || "";
    },
    countNeutral() {
      const count =
        typeof this.filterCounts?.neutral === "number"
          ? this.filterCounts.neutral
          : null;

      return formatBigNumber(count)?.toString() || "";
    },
    countPositive() {
      const count =
        typeof this.filterCounts?.positive === "number"
          ? this.filterCounts.positive
          : null;

      return formatBigNumber(count)?.toString() || "";
    },
  },
  mounted() {
    if (this.incomingSelection?.length) {
      this.selection = this.incomingSelection;
    }
  },
  methods: {
    toggleSelection(val) {
      //Add or remove the selection
      const index = this.selection.indexOf(val);
      if (index > -1) {
        this.selection.splice(index, 1);
      } else {
        this.selection.push(val);
      }

      if (this.selection?.length) {
        this.handlePageTrackerEvent(
          SEARCH_CATEGORIES.live_search_sentiment,
          EVENT_ACTIONS.selected,
          "Sentiment - " + this.selection.join(",")
        );
      } else {
        this.handlePageTrackerEvent(
          SEARCH_CATEGORIES.live_search_sentiment,
          EVENT_ACTIONS.clear,
          "Sentiment"
        );
      }

      this.$emit(EMITTED_ACTIONS.CHANGE, this.selection);
    },
  },
  watch: {
    incomingSelection: {
      handler(newVal) {
        if (newVal !== this.selection) {
          this.selection = newVal;
        }
      },
    },
  },
};
</script>

<style lang="scss">
.chips-container {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-column-gap: 5px;
  font-size: 10px;
  margin-top: 10px;

  .v-chip.v-chip--outlined {
    text-align: center;
    align-self: stretch;
    border-color: $primary-color;
    cursor: pointer;
    padding-left: 5px;
    font-size: 11.5px;

    .v-chip__content {
      width: 100%;
      display: inline-block;
      line-height: 22px;
    }

    &.active {
      background-color: $primary-color !important;
      color: white;
    }

    &.xsmall {
      font-size: 11px;
      padding-left: 1px;
    }
    &.hasCount:not(.xsmall) {
      padding-left: 8px;
    }
  }
}
.sentiment-chip.v-chip {
  padding: 0 !important;
}
</style>
